import React, { Component } from "react";
import Buscador from "./Components/Buscador";
import Resultado from "./Components/Resultado";

class App extends Component {
  state = {
    termino: "",
    imagenes: [],
    pagina: 0,
  };

  scroll = () => {
    const elemento = document.querySelector(".jumbotron");
    elemento.scrollIntoView("smooth", "start");
  };

  paginaAnterior = () => {
    //leer state actual:
    let pagina = this.state.pagina;
    //Si la pag es 1 no ir hacia atras:
    if (pagina === 1) return null;
    //Restar uno a la pagina actual:
    pagina -= 1;
    //Agregar cambio al state:
    this.setState({ pagina }, () => {
      this.consultarAPI(); //Actualiza los componentes imagen desde el método
      this.scroll(); //Subir scroll hasta arriba
    });
  };
  paginaSiguiente = () => {
    //leer state actual:
    let pagina = this.state.pagina;
    //Sumar uno a la pagina actual:
    pagina++;
    //Agregar cambio al state:
    this.setState({ pagina }, () => {
      this.consultarAPI(); //Actualiza los componentes imagen desde el método
      this.scroll(); //Subir scroll hasta arriba
    });
  };

  consultarAPI = () => {
    const pagina = this.state.pagina;
    const termino = this.state.termino;
    const url = `https://pixabay.com/api/?key=17864207-a04adf05717005cd14f5dc9bc&q=${termino}&per_page=30&page=${pagina}`;

    //Trabajando con la respuesta de la API
    fetch(url)
      .then((respuesta) => respuesta.json())
      .then((resultado) => this.setState({ imagenes: resultado.hits }));
  };

  datosBusqueda = (termino) => {
    this.setState(
      {
        termino: termino,
        pagina: 1,
      },
      () => {
        this.consultarAPI();
      }
    );
  };

  render() {
    return (
      <div className="app container">
        <div className="jumbotron">
          <h1 class="display-3">Buscador de Imágenes</h1>
          <hr class="my-4"></hr>
          <Buscador datosBusqueda={this.datosBusqueda} />
        </div>

        <div className="row justify-content-center">
          <Resultado
            imagenes={this.state.imagenes}
            paginaAnterior={this.paginaAnterior}
            paginaSiguiente={this.paginaSiguiente}
          />
        </div>
      </div>
    );
  }
}

export default App;
